import { render } from "./ComprehensiveAnalysisDashboard.vue?vue&type=template&id=e6f09a90&scoped=true"
import script from "./ComprehensiveAnalysisDashboard.vue?vue&type=script&lang=js"
export * from "./ComprehensiveAnalysisDashboard.vue?vue&type=script&lang=js"

import "./ComprehensiveAnalysisDashboard.vue?vue&type=style&index=0&id=e6f09a90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f09a90"]])

export default __exports__